import { render, staticRenderFns } from "./AvisoBaixaEmTodas.vue?vue&type=template&id=117a1c58"
import script from "./AvisoBaixaEmTodas.vue?vue&type=script&lang=js"
export * from "./AvisoBaixaEmTodas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports